import { useState } from 'react';

import { FormDTO, FormElement } from '@gearbelt/global';

import documentsVector from '@/assets/vectors/documents.svg';
import { ListItem } from '@/awa-pages/[workspaceId]/assets/[id]/forms/list-item';
import { AWAInspectionsListDrawer } from '@/awa-pages/[workspaceId]/assets/[id]/inspections/list-drawer';

export function AWAInspectionTemplatesList({
  inspectionTemplates = [],
  assetId,
}: {
  inspectionTemplates: (FormDTO & { elements: FormElement[] })[];
  assetId: string;
}) {
  const [selectedInspectionTemplate, setSelectedInspectionTemplate] = useState<(FormDTO & { elements: FormElement[] }) | null>(null);
  const [isInspectionsListDrawerOpen, setIsInspectionsListDrawerOpen] = useState(false);

  /* No Inspection forms yet */
  if (inspectionTemplates.length === 0) {
    return (
      <div className="flex h-full w-full flex-col items-center gap-2 px-2 py-25">
        <img src={documentsVector} alt="No inspection forms yet" className="h-[170px] w-[250px]" />
        <div className="text-default-text text-center text-xl font-medium">No inspection forms available</div>
        <div className="text-secondary-text text-center text-base font-normal">Inspections forms are created via the Gearbelt website.</div>
      </div>
    );
  }

  return (
    <>
      {/** Initially only one - but upgrade will allowing showing more */}
      <div className="flex h-full w-full flex-col items-center">
        {inspectionTemplates?.map((inspectionTemplate: FormDTO & { elements: FormElement[] }) => (
          <ListItem
            key={inspectionTemplate.id}
            formName={inspectionTemplate.name}
            onClick={() => {
              setSelectedInspectionTemplate(inspectionTemplate);
              setIsInspectionsListDrawerOpen(true);
            }}
          />
        ))}
      </div>

      {selectedInspectionTemplate && (
        <AWAInspectionsListDrawer
          assetId={assetId}
          form={selectedInspectionTemplate}
          open={isInspectionsListDrawerOpen}
          onOpenChange={() => {
            setIsInspectionsListDrawerOpen(false);
          }}
        />
      )}
    </>
  );
}
